import { render, staticRenderFns } from "./GalleryThumb.vue?vue&type=template&id=359c826c&scoped=true&"
import script from "./GalleryThumb.vue?vue&type=script&lang=js&"
export * from "./GalleryThumb.vue?vue&type=script&lang=js&"
import style0 from "./GalleryThumb.vue?vue&type=style&index=0&id=359c826c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359c826c",
  null
  
)

component.options.__file = "GalleryThumb.vue"
export default component.exports